import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '../Icons/Phone';
import { PAGE_HEIGHT } from '../../constants';

const styles = {
  main: {
    backgroundColor: '#dcf7f4',
    minHeight: PAGE_HEIGHT,
    padding: '33px 28px',
  },
  subHeader: {
    marginTop: '24px',
    marginBottom: '20px',
  },
  cardTitle: {
    margin: '10px 0',
  },
  secondaryCard: {
    marginBottom: '14px',
  },
}

export default function Support() {

  return (
    <Box sx={styles.main}>
      <Typography variant="h1">Support</Typography>
      <Typography variant="h3" component="h2" sx={styles.subHeader}>
        Have a question or comment?
      </Typography>
      <Card sx={styles.secondaryCard}>
        <CardContent>
          <MailOutlineIcon style={{ height: '32px', width: '32px' }} />
          <Typography sx={styles.cardTitle} variant="h3">
            Email Support
          </Typography>
          <Typography>
            <a href="mailto:support@differential.com">
              support@differential.com
            </a>
          </Typography>
        </CardContent>
      </Card>
      <Card sx={styles.secondaryCard}>
        <CardContent>
          <PhoneIcon style={{ height: '32px', width: '32px' }} />
          <Typography sx={styles.cardTitle} variant="h3">
            Phone Support
          </Typography>
          <Typography>
            <a href="tel:844-903-3900">(844) 903-3900</a>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
